'use client'

import React, { createContext, ReactNode,useContext, useState } from 'react'

type Execution = {
  id: string
  name: string
  modelName?: string
  method?: string
}

interface ExecutionContextType {
  executions: Execution[]
  selectedExecution: string
  setSelectedExecution: (id: string) => void
  setExecutions: (executions: Execution[]) => void
  hasExecutions: boolean
}

const ExecutionContext = createContext<ExecutionContextType | undefined>(
  undefined
)

export function ExecutionProvider({ children }: { children: ReactNode }) {
  const [executions, setExecutions] = useState<Execution[]>([])
  const [selectedExecution, setSelectedExecution] = useState<string>('0')

  const value = {
    executions,
    selectedExecution,
    setSelectedExecution,
    setExecutions,
    hasExecutions: executions.length > 0
  }

  return (
    <ExecutionContext.Provider value={value}>
      {children}
    </ExecutionContext.Provider>
  )
}

export function useExecution() {
  const context = useContext(ExecutionContext)
  if (context === undefined) {
    throw new Error('useExecution must be used within an ExecutionProvider')
  }
  return context
}
